export default "__VITE_ASSET__BxlKPL7u__"